module.exports = __webpack_public_path__ + "img/4_3.3249844a.jpg";